import {
  ENQUEUE_PUBLISH_JOB,
  REMOVE_PUBLISH_JOB,
  UPDATE_PUBLISH_JOB_PROGRESS,
  MARK_BANNER_LIST_STALE,
  CLEAR_BANNER_LIST_STALE,
  MARK_TEMPLATE_LIST_STALE,
  CLEAR_TEMPLATE_LIST_STALE,
  MARK_PAGES_LIST_STALE,
  CLEAR_PAGES_LIST_STALE,
  MARK_CATEGORIES_LIST_STALE,
  CLEAR_CATEGORIES_LIST_STALE,
  MARK_WIDGETS_LIST_STALE,
  CLEAR_WIDGETS_LIST_STALE,
  MARK_SEO_LIST_STALE,
  CLEAR_SEO_LIST_STALE,
  MARK_INFORMATION_POLICY_LIST_STALE,
  CLEAR_INFORMATION_POLICY_LIST_STALE,
  MARK_ADMIN_SETTINGS_STALE,
  CLEAR_ADMIN_SETTINGS_STALE,
  MARK_CONFIG_SETTINGS_STALE,
  CLEAR_CONFIG_SETTINGS_STALE,
  MARK_TAX_CATEGORY_LIST_STALE,
  CLEAR_TAX_CATEGORY_LIST_STALE,
  MARK_EMPLOYER_LIST_STALE,
  CLEAR_EMPLOYER_LIST_STALE,
  MARK_BRANCH_LIST_STALE,
  CLEAR_BRANCH_LIST_STALE,
  MARK_STAFF_LIST_STALE,
  CLEAR_STAFF_LIST_STALE,
  MARK_SHIFT_LIST_STALE,
  CLEAR_SHIFT_LIST_STALE,
  MARK_TRANSACTION_LIST_STALE,
  CLEAR_TRANSACTION_LIST_STALE,
  MARK_SHIFT_APPLICATION_LIST_STALE,
  CLEAR_SHIFT_APPLICATION_LIST_STALE,
  MARK_TIMESHEET_LIST_STALE,
  CLEAR_TIMESHEET_LIST_STALE,
  MARK_STAFF_DOCUMENTS_LIST_STALE,
  CLEAR_STAFF_DOCUMENTS_LIST_STALE,
  MARK_STAFF_AVAILABILITY_LIST_STALE,
  CLEAR_STAFF_AVAILABILITY_LIST_STALE,
} from '../constants/PendingPublish';

const initState = {
  jobs: [],
  bannerListStale: false,
  templateListStale: false,
  pagesListStale: false,
  categoriesListStale: false,
  widgetsListStale: false,
  seoListStale: false,
  informationPolicyListStale: false,
  adminSettingsStale: false,
  configSettingsStale: false,
  taxCategoryListStale: false,
  employerListStale: false,
  branchListStale: false,
  staffListStale: false,
  shiftListStale: false,
  transactionListStale: false,
  shiftApplicationListStale: false,
  timesheetListStale: false,
  staffDocumentsListStale: false,
  staffAvailabilityListStale: false,
};

const pendingPublish = (state = initState, action) => {
  switch (action.type) {
    case ENQUEUE_PUBLISH_JOB:
      return {
        ...state,
        jobs: [
          {
            ...action.payload,
            status: 'pending',
            phase: 'queued',
            percent: 0,
            error: null,
          },
          ...state.jobs,
        ],
      };
    case UPDATE_PUBLISH_JOB_PROGRESS: {
      const { id, percent, phase, status } = action.payload;
      return {
        ...state,
        jobs: state.jobs.map((job) =>
          job.id === id
            ? {
                ...job,
                ...(typeof percent === 'number' ? { percent } : {}),
                ...(phase ? { phase } : {}),
                ...(status ? { status } : {}),
              }
            : job,
        ),
      };
    }
    case REMOVE_PUBLISH_JOB:
      return {
        ...state,
        jobs: state.jobs.filter((job) => job.id !== action.payload),
      };
    case MARK_BANNER_LIST_STALE:
      return {
        ...state,
        bannerListStale: true,
      };
    case CLEAR_BANNER_LIST_STALE:
      return {
        ...state,
        bannerListStale: false,
      };
    case MARK_TEMPLATE_LIST_STALE:
      return {
        ...state,
        templateListStale: true,
      };
    case CLEAR_TEMPLATE_LIST_STALE:
      return {
        ...state,
        templateListStale: false,
      };
    case MARK_PAGES_LIST_STALE:
      return {
        ...state,
        pagesListStale: true,
      };
    case CLEAR_PAGES_LIST_STALE:
      return {
        ...state,
        pagesListStale: false,
      };
    case MARK_CATEGORIES_LIST_STALE:
      return {
        ...state,
        categoriesListStale: true,
      };
    case CLEAR_CATEGORIES_LIST_STALE:
      return {
        ...state,
        categoriesListStale: false,
      };
    case MARK_WIDGETS_LIST_STALE:
      return {
        ...state,
        widgetsListStale: true,
      };
    case CLEAR_WIDGETS_LIST_STALE:
      return {
        ...state,
        widgetsListStale: false,
      };
    case MARK_SEO_LIST_STALE:
      return {
        ...state,
        seoListStale: true,
      };
    case CLEAR_SEO_LIST_STALE:
      return {
        ...state,
        seoListStale: false,
      };
    case MARK_INFORMATION_POLICY_LIST_STALE:
      return {
        ...state,
        informationPolicyListStale: true,
      };
    case CLEAR_INFORMATION_POLICY_LIST_STALE:
      return {
        ...state,
        informationPolicyListStale: false,
      };
    case MARK_ADMIN_SETTINGS_STALE:
      return {
        ...state,
        adminSettingsStale: true,
      };
    case CLEAR_ADMIN_SETTINGS_STALE:
      return {
        ...state,
        adminSettingsStale: false,
      };
    case MARK_CONFIG_SETTINGS_STALE:
      return {
        ...state,
        configSettingsStale: true,
      };
    case CLEAR_CONFIG_SETTINGS_STALE:
      return {
        ...state,
        configSettingsStale: false,
      };
    case MARK_TAX_CATEGORY_LIST_STALE:
      return {
        ...state,
        taxCategoryListStale: true,
      };
    case CLEAR_TAX_CATEGORY_LIST_STALE:
      return {
        ...state,
        taxCategoryListStale: false,
      };
    case MARK_EMPLOYER_LIST_STALE:
      return {
        ...state,
        employerListStale: true,
      };
    case CLEAR_EMPLOYER_LIST_STALE:
      return {
        ...state,
        employerListStale: false,
      };
    case MARK_BRANCH_LIST_STALE:
      return {
        ...state,
        branchListStale: true,
      };
    case CLEAR_BRANCH_LIST_STALE:
      return {
        ...state,
        branchListStale: false,
      };
    case MARK_STAFF_LIST_STALE:
      return {
        ...state,
        staffListStale: true,
      };
    case CLEAR_STAFF_LIST_STALE:
      return {
        ...state,
        staffListStale: false,
      };
    case MARK_SHIFT_LIST_STALE:
      return {
        ...state,
        shiftListStale: true,
      };
    case CLEAR_SHIFT_LIST_STALE:
      return {
        ...state,
        shiftListStale: false,
      };
    case MARK_TRANSACTION_LIST_STALE:
      return {
        ...state,
        transactionListStale: true,
      };
    case CLEAR_TRANSACTION_LIST_STALE:
      return {
        ...state,
        transactionListStale: false,
      };
    case MARK_SHIFT_APPLICATION_LIST_STALE:
      return {
        ...state,
        shiftApplicationListStale: true,
      };
    case CLEAR_SHIFT_APPLICATION_LIST_STALE:
      return {
        ...state,
        shiftApplicationListStale: false,
      };
    case MARK_TIMESHEET_LIST_STALE:
      return {
        ...state,
        timesheetListStale: true,
      };
    case CLEAR_TIMESHEET_LIST_STALE:
      return {
        ...state,
        timesheetListStale: false,
      };
    case MARK_STAFF_DOCUMENTS_LIST_STALE:
      return {
        ...state,
        staffDocumentsListStale: true,
      };
    case CLEAR_STAFF_DOCUMENTS_LIST_STALE:
      return {
        ...state,
        staffDocumentsListStale: false,
      };
    case MARK_STAFF_AVAILABILITY_LIST_STALE:
      return {
        ...state,
        staffAvailabilityListStale: true,
      };
    case CLEAR_STAFF_AVAILABILITY_LIST_STALE:
      return {
        ...state,
        staffAvailabilityListStale: false,
      };
    default:
      return state;
  }
};

export default pendingPublish;
